import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

export interface AvgTicket {
  start_date: string;
  end_date: string;
  avg_ticket: string;
}

export function useAvgTicket(params: {
  start_date?: string;
  end_date?: string;
}) {
  const fetch = useFetch();
  const search = new URLSearchParams(
    params as Record<string, string>,
  ).toString();

  return useQuery<AvgTicket>({
    queryKey: ["sales-avg-ticket", params],
    queryFn: () =>
      fetch(`${API}/api/semeadora/reports/sales/avg-ticket/?${search}`),
  });
}
